import React, { useEffect, useRef, useState }  from 'react';
import './components.scss';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/customButton/customButton';
import CustomSelect from '../../components/customSelect/customSelect';
import HookForm from '../../components/hookForm/hookForm';
import { Carousel, CarouselIndicators, CarouselItem, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import TextField from '../../components/textField/textField';
import Constant from '../../util/constant';
import { Link } from 'react-router-dom';
import { Controller } from 'react-hook-form';
import OTPInput from 'react-otp-input';
import FileUpload from '../../components/fileUpload/fileUpload';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/features/toast/toastSlice';
import CustomToggleButton from '../../components/customToggleButton/customToggleButton';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-gpx";
import noDataFound from '../../assets/images/noDataFountTrail.svg';
import SearchBar from '../../components/searchBar/searchBar';
const Components: React.FC = () => {
    let triggerRef = useRef(null);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const mapRef = useRef<HTMLDivElement | null>(null);
    const mapInstanceRef = useRef<L.Map | null>(null); // Store map instance
    const tracks = ["https://tapr-re-development.s3.eu-west-2.amazonaws.com/20210707093408.gpx?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEHQaCWV1LXdlc3QtMiJGMEQCIBn5h%2FP2Jy2108Z8V8C4Mn8%2FRlbHGThXzCMGpu73GDZFAiA3QpWsmV021ZRBJYpuYjlscrCejPgY2o4Hnp3v667hYyriAwgsEAQaDDQ2ODIyMDYwMDk4MiIMauTn54eP9KKmfyShKr8D8j2xIMvJNucnVlIaX%2BNK2NuKW%2B0i%2BZhcQiPv4rmAWluWqJlr9PZ0JWSldSQWrZsaFPqP%2FXNU%2BhEPYt%2Bm7TdRU%2B3mQWyUrksg1J665xaOsDSA8HRXL61amNPDeF8jsjG%2BjdvHvomJXTjk%2BxcGWIb5m%2BGW9PCt2a8qrQcpHYLjmqs2Tiy8Wja%2FWV1qVWICCx7pYGoadS4I0Z8HyOoYr09Kf0v4ybYt23Y9Xs4oT9Tyb%2B3VztWEiU1WKSQowy8snlouF8WEiA4x3%2BhLrMANLP3%2FHcWmumMlD%2F0yaBl69bV7zxFSKsqG3jgW08s7xYe7QVz07063ljeVPEmCpeChvUwZ3HzArUBfq2qiMsRYiyseD6IAYYT%2F5vI8FX%2BweKKtPtYBIqa9uH9r4fGjQCizCplcJdUDihaA3GuYFjcBnZT9ChHvPaS85%2FZz5kAVpML%2BL4HAD%2F255RIdXCvHsadhezf3DdrXYQp24gyHeD3Qexebhn3TTqKmaQJRSEHPpVy4PksDFjfDmhWQgIdnsch4qCQY9%2Bx4mXPlLHuZKHm427pys0jcIf885K2K5l%2FkStzPSQwsbPq6tIBh%2BkXr2G3j5BcaML%2F2yboGOuUCmgVr6Pbp12MQTiGelEwbDInRAHpESo5O8WP0FKfmKSlBUER%2FOW%2BbANlh%2BDbzrc66%2BgYvsdAc%2Fy4uYNZdncx56vWD6RezCT4TRk40DbdjsXe8fJ7YNCjIwVLWA94Pkj8RIAtoosyFwN1u%2BxoqZPoM6WWptfS2aRx1OkGX9QhoCaIGdYEPa2MnlyhGj%2Fa%2F84oioAd7t1f87keh%2BL2GLBee5kGgB0wSuQuZUQgTl%2BVxeTsDJP0OUrQne25ddC755d4SOMxAZG1sDiW831PVt%2BDze%2BYcWAF%2FEBYu8G2dy5574IUWfBqfL%2B2TEzAtHWnltSVaaIoa0XUWKdvwnIQcGxjzL3ioBXMIq5K6cswyKOMnkDNkB%2FlW93jU%2BCHQsmDGh0K93z%2FYZcOvAgwNEZ%2B5NckQ0Pl3QwBn9naXLTrm2ZyHoZWwK%2B9IR4u0DDFwVeDyVN6m2930B7biWH60TaW0%2B2RyLKV3fMwg&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAW2BA7MKLGVONR5YF%2F20241206%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20241206T111651Z&X-Amz-Expires=43200&X-Amz-SignedHeaders=host&X-Amz-Signature=aef7699f2458de7d3ac57ae6282833654f7dcf89bbb61dec13c5dd24c230667e"];
    const trackColors = ["red"];
    const [selectedOption, setSelectedOption] = useState<{ label: string, value: string } | null>(null);
    const [singleSelectedOption, setSingleSelectedOption] = useState<{ label: string, value: string } | null>(null);
    const [showPass, setShowPass] = useState(false);
    const [digitValue, setDigitValue] = useState('');
    const [showNewPass, setShowNewPass] = useState(false);
    const [showPassConfirm, setShowPassConfirm] = useState(false);
    const [mediaPreviewShow, setMediaPreviewShow] = useState<any>( []);
    const [mediaFiles, setMediaFiles] = useState<any>([]);
    const [imageLoader, setImageLoader] = useState<boolean>(false);
    const [checked, setChecked] = useState(false);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [searchQuery, setSearchQuery] = useState(''); // State for search input

    const items = [
        {
          src: 'https://picsum.photos/id/123/1200/400',
          altText: 'Slide 1',
          caption: 'Slide 1',
          key: 1,
        },
        {
          src: 'https://picsum.photos/id/456/1200/400',
          altText: 'Slide 2',
          caption: 'Slide 2',
          key: 2,
        },
        {
          src: 'https://picsum.photos/id/678/1200/400',
          altText: 'Slide 3',
          caption: 'Slide 3',
          key: 3,
        },
      ];

      const goToIndex = (newIndex:number) => {
        if (animating) return;
        setActiveIndex(newIndex);
      };

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
      };
    
      const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
      };

    const loadGPXData = async (url: string): Promise<string> => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch GPX data from ${url}`);
            }
            return await response.text();
        } catch (error) {
            console.error("Error loading GPX data:", error);
            throw error;
        }
    };
      const initializeMap = () => {
            if (mapInstanceRef.current) return; // Ensure map is only initialized once
    
            mapInstanceRef.current = L.map(mapRef.current as HTMLDivElement, {
                center: [55.745, -3.384],
                zoom: 14,
            });
    
            // Add base layer (no roads)
            L.tileLayer("https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
                subdomains: "abcd",
                maxZoom: 19,
            }).addTo(mapInstanceRef.current);
    
            // Add label overlay
            L.tileLayer("https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png", {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
                subdomains: "abcd",
                maxZoom: 19,
            }).addTo(mapInstanceRef.current);
        };
    
        const addGPXTracksToMap = async () => {
            try {
                initializeMap();
                const map = mapInstanceRef.current;
    
                for (let i = 0; i < tracks.length; i++) {
                    const gpxData = await loadGPXData(tracks[i]);
    
                    // Add colored track without any markers
                    new L.GPX(gpxData, {
                        polyline_options: {
                            color: trackColors[i % trackColors.length],
                            opacity: 1.0,
                            weight: 4,
                            lineCap: "round",
                        },
                        marker_options: {
                            startIconUrl: "", // Disable start marker
                            endIconUrl: "", // Disable end marker
                            shadowUrl: "", // Disable shadow marker
                            wptIconUrls: {
                                default: "", // Disable waypoint icons
                            },
                        },
                    }).addTo(map!);
                }
            } catch (error) {
                console.error("Error adding GPX tracks:", error);
                setError("Failed to load some or all GPX tracks.");
            } finally {
                setIsLoading(false);
            }
        };
    
        useEffect(() => { 
            addGPXTracksToMap();
        }, []);


    const cancelModal = () => {
        setModal(false);
    }

    const onToggleSwitch = () => { 
        setChecked(!checked);
    };

    const onOpenModal = () => {
        setModal(true);
    };
    const onModalSubmitModal = () => {
        setModal(false);
        dispatch(
            showToast({
                show: false,
                message: 'Data Submitted successfully.',
                type: "success",
            })
            );
    }

    const options = [
        { label: 'option 1', value: 'option 1' },
        { label: 'option 2', value: 'option 2' },
        { label: 'option 3', value: 'option 3' },
        { label: 'option 4', value: 'option 4' },
    ];
    const singleOptions = [
        { label: 'option 1', value: 'option 1' },
        { label: 'option 2', value: 'option 2' },
        { label: 'option 3', value: 'option 3' },
        { label: 'option 4', value: 'option 4' },
    ];

    const uploadThumNailValid = {
        "image/png": ".png",
        "image/jpg": ".jpg",
        "image/jpeg": ".jpeg"
    };

    const multiErrorFields = [
        { length: t('MINIMUM_8_CHARACTERS') },
        { hasSpecialChar: t('MINIMUM_1_SPECIAL_CHARACTER') },
        { hasNumbers: t('MINIMUM_1_NUMERIC_CHARACTER') },
        { hasUppercase: t('MINIMUM_1_UPPERCASE_CHARACTER') },
        { hasLowerCase: t('MINIMUM_1_LOWERCASE_CHARACTER') },
    ];

    const componentsForm = {
        thumbnailFile: {
            name: "thumbnailFile",
            validate: {
                required: {
                value: false,
                },
            },
        },
        email: {
            name: 'email',
            validate: {
                required: {
                    value: true
                },
                pattern: {
                    value: Constant.REGEX.EMAIL,
                    message: t('PLEASE_ENTER_A_VALID_EMAIL_ADDRESS')
                }
            }
        },
        password: {
            name: 'password',
            validate: {
                required: {
                    value: true
                }
            }
        },
        textfield: {
            name: 'textfield',
            validate: {
                required: {
                    value: true
                },
                pattern: {
                    value: Constant.REGEX.NAME,
                    message: t('ENTER_VALID_NAME')
                },
                maxLength: {
                    value: 250,
                    message: 'Max. 250 characters are allowed',
                },
            }
        },
        textarea: {
            name: 'textarea',
            validate: {
                required: {
                    value: true
                }
            }
        },
        leftLabel: {
            name: 'leftLabel',
            validate: {
                required: {
                    value: true
                }
            }
        },
        select: {
            name: 'select'
        },
        singleSelect: {
            name: 'singleSelect'
        },
        newPassword: {
            name: "newPassword",
            validate: {
                required: {
                    value: true,
                },
                validate: {
                    hasUppercase: (value: string) =>
                        value && value.match(Constant.REGEX.UPPERCASE) !== null,
                    hasLowerCase: (value: string) =>
                        value && value.match(Constant.REGEX.LOWERCASE) !== null,
                    hasNumbers: (value: string) =>
                        value && value.match(Constant.REGEX.NUMBER) !== null,
                    hasSpecialChar: (value: string) =>
                        value && value.match(Constant.REGEX.SPECIALCHARACTERS) !== null,
                    length: (value: string) => (value && value.length >= 8) || "",
                },
            },
        },
        confirmPassword: {
            name: "confirmPassword",
        },
    };

    const removeMediaFile = (index: number) => {
        const updatedMediaFiles = [...mediaFiles];
        const updatedMediaFilesURL = [...mediaPreviewShow];

        updatedMediaFiles.splice(index, 1);
        updatedMediaFilesURL.splice(index, 1);
        setMediaFiles(updatedMediaFiles);
        setMediaPreviewShow(updatedMediaFilesURL);
    };
    const handleUploadThumnailFile = async (files: Blob[]) => {
        console.log("filesProgram: ", files);
        if (files && files.length > 0) {
          setImageLoader(true); // Show loader while uploading
          const updatedMediaFiles = [...mediaFiles]; // Create a copy of current mediaFiles array
          console.log("updatedMediaFiles760: ", updatedMediaFiles);
          const updatedMediaFilesURL = [...mediaFiles]; // Create a copy of current mediaFiles array
          console.log("updatedMediaFilesURL: ", updatedMediaFilesURL);
    
          const processFile = (file: Blob) => {
            return new Promise<void>((resolve, reject) => {
              const fileSize = file.size;
              const reader = new FileReader();
              if (file.type.startsWith("image/")) {
                reader.onload = (event: any) => {
                  const fileData = event.target.result; // Get the base64 data
                  const image = new Image();
    
                  image.onload = () => {
                    const width = image.width;
                    const height = image.height;    
                    const fileWithSize = {
                      data: fileData,
                      size: fileSize,
                      width: width,
                      height: height,
                    };
                    updatedMediaFiles.push(fileWithSize); // Add image file to updatedMediaFiles array
                    resolve();
                  };
                  image.src = event.target.result;
                };
                reader.readAsDataURL(file); // Read image file as Data URL (base64)
              } else {
                resolve(); // Skip unsupported file types
              }
            });
          };
    
          // Process all files
          const processingPromises = files.map((file) => processFile(file));
    
          // Wait for all files to be processed
          await Promise.all(processingPromises);
    
          // Limit the total number of files in the array to 5
          const finalMediaFiles = updatedMediaFiles.slice(0, 4);
    
          // Update state after all files are processed
          setImageLoader(false); // Hide loader once all files are uploaded
          setMediaPreviewShow(finalMediaFiles);
          setMediaFiles(finalMediaFiles);
        } else {
          setImageLoader(false);
        //   setOrgImage("");
        }
      };

    const handleOptionChange = (selected: any) => {
        setSelectedOption(selected);
    };
    const handleSingleOptionChange = (selected: any) => {
        setSingleSelectedOption(selected);
    };

    const onOtpChange = (value: React.SetStateAction<string>) => {
        setDigitValue(value);
    };
    const onFormSubmit = (e:any) => {        
    };

    const onSuccessToastClick = (e:any) => {
        dispatch(
        showToast({
            show: false,
            message: 'Success Toast Message',
            type: "success",
        })
        );

    };
    const onErrorToastClick = (e:any) => {
        dispatch(
        showToast({
            show: false,
            message: 'Error Toast Message',
            type: "error",
        })
        );

    };
    const handleSearchChange = (event: string) => {
        setSearchQuery(event);
      };
    return (
        <div className={"main-container container components emptyDataContainer"}>
            <div className='whiteBg'>
                    <h1>Components</h1>
                    <div className='componentWrapper'>
                        <div className='leftpart'>
                            <h3 className='my-3'>Solid Button</h3>
                            <div className='d-flex flex-row gap-2 flex-wrap'>
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-primary text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-secondary text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-success text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-danger text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-warning text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-info text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-light text-white " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-dark text-white " 
                                />
                            </div>                        
                            <h3 className='my-3'>Outline Button</h3>
                            <div className='d-flex flex-row gap-2 flex-wrap'>
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-primary " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-secondary" 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-success" 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-danger " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-warning " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-info " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-light " 
                                />
                                <CustomButton 
                                    title={t("BUTTON")} 
                                    className="btn btn-outline-dark " 
                                />
                            </div>       
                            <h3 className='my-3'>Search Component</h3>
                                <SearchBar placeholder={t('SEARCH_BY_TITLE')} onChange={(e: any) => { handleSearchChange(e); } } onClear={()=>(setSearchQuery(''))} />
                            <h3 className='my-3'>Link</h3>
                            <div className='forgotPassLink'>
                                <Link to="/" className='text-primary'>
                                    {t("LINK")}
                                </Link>
                            </div> 
                            <h3 className='my-3'>Toast Components</h3>
                            <div className='toastComponents'>
                                <CustomButton 
                                    onClick={onSuccessToastClick}
                                    title={t("CLICK_ME")} 
                                    className="btn btn-primary text-white " 
                                />
                                <CustomButton 
                                    onClick={onErrorToastClick}
                                    title={t("CLICK_ME")} 
                                    className="btn btn-outline-danger " 
                                />
                            </div>
                            <h3 className='my-3'>Switch Components</h3>
                            <div>
                                <CustomToggleButton checked={checked} id={''} onCheckChange={onToggleSwitch} />
                            </div>
                            <h3 className='my-3'>Custom Modal Components</h3>
                                <CustomButton 
                                    onClick={onOpenModal}
                                    title={t("CLICK_ME")} 
                                    className="btn btn-outline-danger " 
                                />
                            <h3 className='my-3'>Shimir </h3>
                            <div className='placeholder-glow'>
                                <span className='selectBox filterSelect placeholder w-100 me-3'></span>
                                <span className='selectBox filterSelect placeholder w-100 me-3'></span>
                                <span className='selectBox filterSelect placeholder w-100 '></span>
                            </div>
                            <h3 className='my-3'>Card Components</h3>
                            <div className='cardComponents'>
                                <div className='cardWrapper'>
                                    <div className='whiteCard'>
                                        <div className="cardImg">
                                            <img src='https://images.pexels.com/photos/163407/cyclists-trail-bike-clouds-163407.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt='Trail Image' />
                                        </div>
                                        <div className="cardContent">
                                            <div className="cardTitle">first Abbotsford House Circular Walking & Running Route</div>
                                            <div className="contentBtm">
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("DIFFICULTY")}
                                                </div>
                                                <div className='data cardTextYellow'>
                                                    Intermediate
                                                </div>
                                            </div>
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("LENGTH")}
                                                </div>
                                                <div className="data">
                                                    1.15 {t("MILES")}
                                                </div>
                                            </div>
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("TIME")}
                                                </div>
                                                <div className="data">
                                                    2 H 11 Min
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='whiteCard disable'>
                                        <div className="cardImg">
                                            <img src='https://images.pexels.com/photos/163407/cyclists-trail-bike-clouds-163407.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt='Trail Image' />
                                        </div>
                                        <div className="cardContent">
                                            <div className="cardTitle">first Abbotsford House Circular Walking & Running Route</div>
                                            <div className="contentBtm">
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("DIFFICULTY")}
                                                </div>
                                                <div className='data cardTextYellow'>
                                                    Intermediate
                                                </div>
                                            </div>
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("LENGTH")}
                                                </div>
                                                <div className="data">
                                                    1.15 {t("MILES")}
                                                </div>
                                            </div>
                                            <div className="dataWrapper">
                                                <div className="label">
                                                {t("TIME")}
                                                </div>
                                                <div className="data">
                                                    2 H 11 Min
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3 className='my-3'>Carousal Component</h3>
                            <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                                <CarouselIndicators
                                items={items}
                                activeIndex={activeIndex}
                                onClickHandler={goToIndex} 
                                />
                                    {items.map((item) => (
                                        <CarouselItem
                                        key={item.key}
                                        onExiting={() => setAnimating(true)}
                                        onExited={() => setAnimating(false)}
                                        >
                                            <img src={item.src} alt={item.altText} />
                                        </CarouselItem>
                                    ))}
                            </Carousel>
                        </div>
                        <div className='rightpart'>
                            <h3 className='my-3'>Form</h3>
                            <HookForm
                                // defaultForm={{}}
                                onSubmit={async (formData) => {
                                    onFormSubmit(formData);
                                }}
                            >
                                {(formMethod) => {
                                    return (
                                        <>
                                            <div className="mb-5">

                                                <div className={
                                                    mediaPreviewShow?.length > 0
                                                    ? "image-part imageRevert"
                                                    : "image-part"}>
                                                    <Controller
                                                    name={componentsForm.thumbnailFile.name}
                                                    rules={{
                                                        required: {
                                                        value: false,
                                                        message: t("THUMBNAIL_FILE_IS_REQUIRED"),
                                                        },
                                                    }}
                                                    control={formMethod.control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <>
                                                        {mediaPreviewShow?.length !== 0 && (
                                                            <>
                                                            {mediaPreviewShow?.map((item: any, index: number) => (
                                                                <>
                                                                <div className="iconWrapper">
                                                                    <img
                                                                    className="uploaded"
                                                                    src={item?.data}
                                                                    alt="preview"
                                                                    />
                                                                    <span onClick={() => removeMediaFile(index)}>{t("REMOVE")}</span>
                                                                </div>
                                                                </>
                                                            ))}
                                                            </>
                                                        )}
                                                        {mediaPreviewShow?.length < 4 && ( 
                                                            <FileUpload
                                                            onDrop={async (acceptedFiles) => {
                                                                console.log("acceptedFiles", acceptedFiles);

                                                                const validFileTypes =
                                                                Object.keys(uploadThumNailValid);
                                                                const validFiles = acceptedFiles.filter((file) =>
                                                                validFileTypes.includes(file.type)
                                                                );

                                                                if (validFiles.length > 0) {
                                                                setImageLoader(true);
                                                                handleUploadThumnailFile(validFiles);
                                                                }

                                                                onChange({
                                                                acceptedFiles,
                                                                });
                                                            }}
                                                            accept={uploadThumNailValid}
                                                            multiple={true}
                                                            // maxFiles={5}
                                                            triggerOpen={triggerRef}
                                                            >
                                                            {imageLoader ? (
                                                                <div className="progress-wrapper">
                                                                <div className="progress">
                                                                    <div className="progress-value"></div>
                                                                </div>
                                                                <p>{t("UPLOADING")}</p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                {mediaPreviewShow?.length < 4 && (
                                                                    <div className="dropZoneWrapper">
                                                                    <i className="icon icon-plus-lg"></i>
                                                                    <span>{t("UPLOAD")}</span>
                                                                    </div>
                                                                )}
                                                                </>
                                                            )}
                                                            </FileUpload>
                                                        )}
                                                        </>
                                                    )}
                                                    />
                                                </div>

                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("EMAIL_ADDRESS")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                    <TextField
                                                        formMethod={formMethod}
                                                        rules={componentsForm.email.validate}
                                                        name={componentsForm.email.name}
                                                        errors={formMethod?.formState.errors}
                                                        autoFocus={true}
                                                        required={true}
                                                        type="email"
                                                        placeholder={t("ENTER_EMAIL_ADDRESS")}
                                                        value={formMethod.getValues(componentsForm.email.name)}
                                                    />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("PASSWORD")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                    <div className='passWrapper'>
                                                        <TextField
                                                            formMethod={formMethod}
                                                            rules={componentsForm.password.validate}
                                                            name={componentsForm.password.name}
                                                            errors={formMethod?.formState.errors}
                                                            autoFocus={false}
                                                            required={true}
                                                            type={showPass ? "text" : 'password'}
                                                            placeholder={t("ENTER_PASSWORD")}
                                                        />
                                                        <i onClick={() => setShowPass(!showPass)} className={showPass ? "icon icon-eye-fill" : "icon icon-eye-slash-fill"}></i>
                                                    </div>
                                                </div>
                                                <div className="texFeildWrapper mb-3">
                                                    <div className="d-flex">
                                                        <Label className="lable">{t("NEW_PASSWORD")}</Label>
                                                        <span className="redStar mx-2">*</span>
                                                    </div>
                                                    <div className="passWrapper">
                                                        <TextField
                                                            formMethod={formMethod}
                                                            rules={componentsForm.newPassword.validate}
                                                            name={componentsForm.newPassword.name}
                                                            multiErrorFields={multiErrorFields}
                                                            errors={formMethod?.formState.errors}
                                                            type={showNewPass ? "text" : "password"}
                                                            placeholder={t("ENTER_NEW_PASSWORD")}
                                                            onChange={() => {
                                                                formMethod?.watch('confirmPassword') &&
                                                                    formMethod.trigger('confirmPassword');
                                                            }}
                                                            triggerValidation={(fieldName) => {
                                                                if (fieldName === "newPassword") {
                                                                formMethod.trigger("confirmPassword"); // Revalidate confirmPassword when newPassword changes
                                                                }
                                                            }}
                                                        />
                                                        <i onClick={() => setShowNewPass(!showNewPass)} className={showNewPass ? "icon icon-eye-fill" : "icon icon-eye-slash-fill"}></i>
                                                    </div>
                                                </div>
                                                <div className="texFeildWrapper mb-3">
                                                    <div className="d-flex">
                                                        <Label className="lable">{t("CONFIRM_PASSWORD")}</Label>
                                                        <span className="redStar mx-2">*</span>
                                                    </div>
                                                    <div className="passWrapper">
                                                    <TextField
                                                        formMethod={formMethod}
                                                        rules={{
                                                            required: {
                                                                value: true,
                                                            },
                                                            validate: {
                                                                matchPassword: (value: string) =>
                                                                    (value &&
                                                                    value === formMethod?.watch("newPassword")) ||
                                                                    t('BOTH_PASSWORD_MUST_BE_MATCH'),
                                                                },
                                                        }}
                                                        name={componentsForm.confirmPassword.name}
                                                        errors={formMethod?.formState.errors}
                                                        type={showPassConfirm ? "text" : "password"}
                                                        placeholder={t("CONFIRM_PASSWORD")}
                                                        />
                                                        <i onClick={() => setShowPassConfirm(!showPassConfirm)} className={showPassConfirm ? "icon icon-eye-fill" : "icon icon-eye-slash-fill"}></i>             
                                                    </div>
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("OTP")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                    <Controller
                                                    name="otp"
                                                    rules={{
                                                        required: { value: true, message: 'OTP is required' },
                                                    }}
                                                    control={formMethod.control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <OTPInput
                                                        onChange={(otp) => {
                                                            const sanitizedOtp = otp.replace(/\D/g, ''); // Remove non-digits
                                                            onOtpChange(sanitizedOtp);
                                                            onChange(sanitizedOtp);
                                                        }}
                                                        onPaste={(e) => {
                                                            e.preventDefault();
                                                            const pastedText = e.clipboardData.getData('Text');
                                                            const sanitizedText = pastedText.replace(/\D/g, ''); // Remove non-digits
                                                            onOtpChange(sanitizedText);
                                                            onChange(sanitizedText);
                                                        }}
                                                        value={digitValue || ''}
                                                        numInputs={6}
                                                        placeholder="000000"
                                                        inputType="tel"
                                                        containerStyle="otp-container pb-3 mb-3"
                                                        renderInput={(inputProps, index) => (
                                                            <input
                                                            {...inputProps}
                                                            key={index}
                                                            className={
                                                                inputProps.value === ''
                                                                ? 'form-control otp-input-none-style'
                                                                : 'form-control otpInputFillStyle'
                                                            }
                                                            />
                                                        )}
                                                        />
                                                    )}
                                                    />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("TEXT_AREA")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                        <TextField
                                                            formMethod={formMethod}
                                                            rules={componentsForm.textarea.validate}
                                                            name={componentsForm.textarea.name}
                                                            errors={formMethod?.formState.errors}
                                                            autoFocus={false}
                                                            textarea={true}
                                                            required={true}
                                                            type="textarea"
                                                            placeholder={t("TEXT_AREA")}
                                                        />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("LEFT_LABEL_INPUT")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                        <TextField
                                                        formMethod={formMethod}
                                                        rules={componentsForm.leftLabel.validate}
                                                        name={componentsForm.leftLabel.name}
                                                        errors={formMethod?.formState.errors}
                                                        autoFocus={false}
                                                        required={true}
                                                        type='number'
                                                        leftLabel={true}
                                                        placeholder={t("00")} 
                                                        twoDecimal={true}
                                                        maxWords={10}/>
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("TEXTFIELD")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                        <TextField
                                                            formMethod={formMethod}
                                                            rules={componentsForm.textfield.validate}
                                                            name={componentsForm.textfield.name}
                                                            errors={formMethod?.formState.errors}
                                                            autoFocus={false}
                                                            required={true}
                                                            type="text"
                                                            placeholder={t("TEXTFIELD")}
                                                        />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("TEXTFIELD")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                        <TextField
                                                            formMethod={formMethod}
                                                            rules={componentsForm.textfield.validate}
                                                            name={componentsForm.textfield.name}
                                                            errors={formMethod?.formState.errors}
                                                            autoFocus={false}
                                                            required={true}
                                                            type="file"
                                                            placeholder={t("TEXTFIELD")}
                                                        />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("SELECT")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                    <Controller
                                                        name={componentsForm.select.name}
                                                        rules={{
                                                        required: {
                                                            value: true,
                                                            message:''
                                                        },
                                                        }}
                                                        control={formMethod.control}
                                                        defaultValue={selectedOption} 
                                                        render={({ field }) => (
                                                        <CustomSelect
                                                            isMulti
                                                            value={selectedOption}
                                                            onChange={(option: any) => {
                                                                handleOptionChange(option);
                                                                field.onChange(option);  
                                                                }}
                                                            closeMenuOnSelect={false}
                                                            placeholder={t("SELECT")}
                                                            isClearable 
                                                            options={options}
                                                            isSearchable={false}
                                                            hideSelectedOptions={false}
                                                            className=""
                                                            classNamePrefix="react-select"
                                                        />   
                                                        )}
                                                    />
                                                </div>
                                                <div className='texFeildWrapper mb-3'>
                                                    <div className="d-flex">
                                                        <Label className='lable'>{t("SINGLE_SELECT")}</Label> <span className='redStar mx-2'>*</span>
                                                    </div>
                                                    <Controller
                                                        name={componentsForm.singleSelect.name}
                                                        rules={{
                                                        required: {
                                                            value: true,
                                                            message:''
                                                        },
                                                        }}
                                                        control={formMethod.control}
                                                        defaultValue={singleSelectedOption} 
                                                        render={({ field }) => (
                                                        <CustomSelect
                                                            value={singleSelectedOption}
                                                            onChange={(option: any) => {
                                                                handleSingleOptionChange(option);
                                                                field.onChange(option);  
                                                                }}
                                                            closeMenuOnSelect={false}
                                                            placeholder={t("SELECT")}
                                                            isClearable 
                                                            options={singleOptions}
                                                            isSearchable={false}
                                                            hideSelectedOptions={false}
                                                            className=""
                                                            classNamePrefix="react-select"
                                                        />   
                                                        )}
                                                    />
                                                </div>
                                            </div> 
                                            <div className="submitDiv">
                                                <CustomButton
                                                    className="btn btn-danger text-white btn-lg w-100 text-center justify-content-center"
                                                    type="submit"
                                                    title={ t("FORM_SUBMIT")}
                                                    disabled={!formMethod?.formState.isValid || digitValue?.length < 6 || mediaFiles?.length === 0}
                                                />
                                            </div>
                                        </>
                                    );
                                }}
                            </HookForm>
                        </div>
                    </div>
                    <div className=''>
                        <h3 className='my-3'>Map Components</h3>
                        <div className='mapComponents'>
                            <div ref={mapRef} style={{ width: "100%", height: "456px" }} />
                        </div>
                        <h3 className='my-3'>No Data Found Components</h3>
                        <div className='noDataFont'>
                            <div className='emptyImage'>
                                <img src={noDataFound} alt="No Trail" />
                            </div>
                            <div className='emptyContent'>
                                <h5 className='title mb-3'>
                                    {t("NO_SEARCH_DATA_FOUND")}
                                </h5>
                                <div className='description mb-3'>
                                    {t("NO_DATA_FOUND_SEARCH_DESCRIPTION")}
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <Modal isOpen={modal} toggle={cancelModal} className="mainModal" centered>
                <ModalHeader toggle={cancelModal}> {t("MODAL_HEADER") }</ModalHeader>
                <ModalBody>
                    {t("MODAL_DESCRIPTION")}
                </ModalBody>
                <ModalFooter>
                    <CustomButton
                        type="button"
                        className="btn btn-danger text-white"
                        onClick={onModalSubmitModal}
                        title={t("SUBMIT")}
                    />
                    <CustomButton
                        type="button"
                        className="btn btn-transparent"
                        onClick={cancelModal}
                        title={t('CANCEL')}
                    />
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default Components;
